import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";
import { Description } from "../../../components/Description";
import styles from "../../../components/ListDescriptions/styles.module.css";
import PassagensComerciais from "./PassagensComerciais";



import { formatarParaMoedaBRL, formatarCNPJ } from "../../../utils";

export default function GPS({
  gps,
  ocultarPassagens = false
}: {
  gps: any,
  ocultarPassagens?: boolean
}) {
  const { t } = useTranslation();

  const valorBodyTemplate = (rowData: any) => {
    if (rowData.VALOR.includes('R$')) {
      return rowData.VALOR;
    }
    const valor = rowData.VALOR ? parseFloat(rowData.VALOR.replace(/\./g, '').replace(',', '.')) : 0;
    return formatarParaMoedaBRL(valor);
  };


  const getProtestoData = () => {
    if (gps.PROTESTOS && gps.PROTESTOS.OCORRENCIAS && gps.PROTESTOS.OCORRENCIAS.length > 0) {
      return gps.PROTESTOS;
    }
    return gps.PROTESTO_SINTETICO;
  }

  const headerTemplateProtesto = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    const protesto = getProtestoData();
    return <div className={className}> {protesto && protesto.OCORRENCIAS && protesto.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span>)}</div>;
  }

  const headerTemplatePendencia = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {gps.PEND_FINANCEIRAS && gps.PEND_FINANCEIRAS.OCORRENCIAS && gps.PEND_FINANCEIRAS.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('restricaoMercado')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('restricaoMercado')}</span>)}</div>;
  }

  const getResumoProtesto = () => {
    const resumos: any[] = [];
    const protesto = getProtestoData();
    if (protesto && protesto.OCORRENCIAS && protesto.OCORRENCIAS.length > 0) {
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Protestos',
        value: protesto.QUANTIDADE_OCORRENCIA
      })
      resumos.push({
        icon: 'pi pi-gauge',
        label: 'Data Ultimo Protesto',
        value: protesto.ULTIMO_PROTESTO
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total Protestos',
        value: 0
      })
      const valorTotal = protesto.VALOR_TOTAL ? parseFloat(protesto.VALOR_TOTAL.replace(/\./g, '').replace(',', '.')) : 0;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }

    return resumos;
  }

  const getResumoPendencia = () => {
    const resumos: any[] = [];
    if (gps?.PEND_FINANCEIRAS && gps?.PEND_FINANCEIRAS?.OCORRENCIAS && gps?.PEND_FINANCEIRAS?.OCORRENCIAS.length > 0) {
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Pendências',
        value: gps?.PEND_FINANCEIRAS?.QUANTIDADE_OCORRENCIA || gps?.PEND_FINANCEIRAS?.OCORRENCIAS.length
      });
      resumos.push({
        icon: 'pi pi-gauge',
        label: 'Data Última Pendência',
        value: gps?.PEND_FINANCEIRAS?.ULTIMA_PENDENCIA || gps?.PEND_FINANCEIRAS?.DATA_ULTIMA_OCORRENCIA || gps?.PEND_FINANCEIRAS?.OCORRENCIAS[0]?.DATA_INCLUSAO || '-'
      });
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total Pendências',
        value: 0
      });
      let valorTotal = 0.0;
      gps?.PEND_FINANCEIRAS?.OCORRENCIAS.forEach((pend: any) => {
        if (pend.VALOR) {
          let strValor = pend.VALOR;
          if (typeof strValor === 'string') {
            strValor = strValor.replace('R$', '').replace(/\./g, '').replace(',', '.');
          }
          valorTotal = valorTotal + Number(strValor);
        }
      });
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }

    return resumos;
  }

  return (
    <div>
      {gps.mensagemErro ? (<p>{gps.mensagemErro}</p>) :
        (<div>
          {gps.DADOS_RECEITA_FEDERAL && (
            <Panel header={t('Dados Receita Federal')}>
              <div className={styles.wrapper}>
                <div className={styles.gridContainer} style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
                  <Description label={t('Nome')} value={gps.DADOS_RECEITA_FEDERAL.NOME} />
                  <Description label={t('Data Nascimento/Fundação')} value={gps.DADOS_RECEITA_FEDERAL.DATA_NASCIMENTO_FUNDACAO} />
                  <Description label={t('Situação Receita')} value={gps.DADOS_RECEITA_FEDERAL.SITUACAO_RECEITA} />
                  <Description label={t('Data Atualização')} value={gps.DADOS_RECEITA_FEDERAL.DATA_ATUALIZACAO} />
                  <Description label={t('Sexo')} value={gps.DADOS_RECEITA_FEDERAL.SEXO} />
                  <Description label={t('Nome da Mãe')} value={gps.DADOS_RECEITA_FEDERAL.NOME_MAE} />
                </div>
              </div>
            </Panel>
          )}
          <br />
          {gps.PARENTES && gps.PARENTES.INFOCONTATOS && gps.PARENTES.INFOCONTATOS.length > 0 && (
            <Panel header={t('Parentes')}>
              <DataTable className="mobile-text-left" size="small" value={gps.PARENTES.INFOCONTATOS} responsiveLayout="stack" breakpoint="960px">
                <Column field="NOME" header={t('Nome')}></Column>
                <Column field="RELACAO" header={t('Relação')}></Column>
                <Column field="NASCIMENTO" header={t('Data Nascimento')}></Column>
                <Column field="DOCUMENTO" header={t('Documento')}></Column>
                <Column field="TIPO_PESSOA" header={t('Tipo Pessoa')}></Column>
              </DataTable>
            </Panel>
          )}
          <br />



          {gps.CH_SEM_FUNDOS_BACEN && (
            <Panel header="Cheques sem Fundos (BACEN)" className="panel-header-azul" toggleable={true}>
              {Number(gps.CH_SEM_FUNDOS_BACEN?.QUANTIDADE_OCORRENCIA) > 0 ? (
                <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "5px 15px" }}>
                  <div>
                    <Description label="Quantidade Ocorrências" value={gps.CH_SEM_FUNDOS_BACEN?.QUANTIDADE_OCORRENCIA} />
                    <Description label="Correntista" value={gps.CH_SEM_FUNDOS_BACEN?.CORRENTISTA} />
                  </div>
                  <div>
                    <Description label="CPF/CNPJ" value={gps.CH_SEM_FUNDOS_BACEN?.CPFCNPJ} />
                    <Description label="Tipo de Pessoa" value={gps.CH_SEM_FUNDOS_BACEN?.TIPO_PESSOA} />
                  </div>
                </section>
              ) : (
                <NadaConsta />
              )}
            </Panel>
          )}
          <br />
          {gps.PARTICIPACAO_EM_EMPRESAS && gps.PARTICIPACAO_EM_EMPRESAS.OCORRENCIAS && gps.PARTICIPACAO_EM_EMPRESAS.OCORRENCIAS.length > 0 && (
            <Panel header={t('Participação em Empresas')}>
              <DataTable className="mobile-text-left" size="small" value={gps.PARTICIPACAO_EM_EMPRESAS.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px">
                <Column field="RAZAO_SOCIAL" header={t('Razão Social')}></Column>
                <Column field="CNPJ" header={t('CNPJ')} body={(rowData) => formatarCNPJ(rowData.CNPJ)}></Column>
                <Column field="PARTICIPACAO" header={t('Participação (%)')}></Column>
                <Column field="PARTICIPANTE_CARGO" header={t('Cargo')}></Column>
              </DataTable>
            </Panel>
          )}
          <br />
          <Panel headerTemplate={headerTemplateProtesto}>
            {!getProtestoData()?.OCORRENCIAS || getProtestoData()?.OCORRENCIAS?.length === 0 ? (<NadaConsta />) : (<>
              <div className="flex-consulta  flex-wrap gap-3">
                {getResumoProtesto().map((item: any, index: number) => (

                  <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
                    <div className="flex-consulta  justify-content-between gap-5">
                      <div className="flex-consulta  flex-column gap-1">
                        <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                        <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                        <i className={item.icon} />
                      </span>
                    </div>
                  </Card>

                ))}
              </div>
              <br></br>
              <DataTable size="small" value={getProtestoData()?.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
                <Column field="DATA_OCORRENCIA" header={t('data')}></Column>
                <Column field="CARTORIO" header={t('cartorio')}></Column>
                <Column field="COMARCA" header={t('cidade')}></Column>
                <Column field="UF" header={t('uf')}></Column>
                <Column field="VALOR" header={t('valor')}></Column>
              </DataTable>
            </>)}
          </Panel>
          <br />
          <Panel headerTemplate={headerTemplatePendencia}>

            {!gps.PEND_FINANCEIRAS || !gps.PEND_FINANCEIRAS.OCORRENCIAS || gps.PEND_FINANCEIRAS.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (<>
              <div className="flex-consulta  flex-wrap gap-3">
                {getResumoPendencia().map((item: any, index: number) => (

                  <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
                    <div className="flex-consulta  justify-content-between gap-5">
                      <div className="flex-consulta  flex-column gap-1">
                        <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                        <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                        <i className={item.icon} />
                      </span>
                    </div>
                  </Card>

                ))}
              </div>
              <br></br>
              <DataTable className="mobile-text-left" size="small" value={gps.PEND_FINANCEIRAS.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px">
                <Column field="DATA_INCLUSAO" header={t('data')}></Column>
                <Column field="DATA_VENCIMENTO" header={t('vencimento')}></Column>
                <Column field="CONTRATO" header={t('contrato')}></Column>
                <Column field="CREDOR" header={t('informante')}></Column>
                <Column field="VALOR" header={t('valor')} body={valorBodyTemplate}></Column>
              </DataTable>
            </>)}
          </Panel>
          <br />
          {!ocultarPassagens && (
            <>
              <PassagensComerciais passagens={gps.PASSAGENS_COMERCIAIS} />
              <br />
            </>
          )}
        </div>)}
    </div>
  )
}
